import {
  CREATE_CARE_PLAN_FAIL,
  CREATE_CARE_PLAN_REQUEST,
  CREATE_CARE_PLAN_SUCCESS,
  CREATE_GOAL_PLAN_FAIL,
  CREATE_GOAL_PLAN_REQUEST,
  CREATE_GOAL_PLAN_SUCCESS,
  CREATE_MEDICATION_PLAN_FAIL,
  CREATE_MEDICATION_PLAN_REQUEST,
  CREATE_MEDICATION_PLAN_SUCCESS,
  CREATE_PLAN_ASSESSMENT_FAIL,
  CREATE_PLAN_ASSESSMENT_REQUEST,
  CREATE_PLAN_ASSESSMENT_SUCCESS,
  CREATE_PLAN_INTERVENTION_FAIL,
  CREATE_PLAN_INTERVENTION_REQUEST,
  CREATE_PLAN_INTERVENTION_SUCCESS,
  CREATE_PLAN_MEMBER_FAIL,
  CREATE_PLAN_MEMBER_REQUEST,
  CREATE_PLAN_MEMBER_SUCCESS,
  CREATE_PLAN_PROBLEM_FAIL,
  CREATE_PLAN_PROBLEM_REQUEST,
  CREATE_PLAN_PROBLEM_SUCCESS,
  CREATE_PLAN_SOCIAL_CONTEXT_FAIL,
  CREATE_PLAN_SOCIAL_CONTEXT_REQUEST,
  CREATE_PLAN_SOCIAL_CONTEXT_SUCCESS,
  EDIT_GOAL_PLAN_FAIL,
  EDIT_GOAL_PLAN_REQUEST,
  EDIT_GOAL_PLAN_SUCCESS,
  EDIT_MEDICATION_PLAN_FAIL,
  EDIT_MEDICATION_PLAN_REQUEST,
  EDIT_MEDICATION_PLAN_SUCCESS,
  EDIT_PLAN_INTERVENTION_FAIL,
  EDIT_PLAN_INTERVENTION_REQUEST,
  EDIT_PLAN_INTERVENTION_SUCCESS,
  EDIT_PLAN_MEMBER_FAIL,
  EDIT_PLAN_MEMBER_REQUEST,
  EDIT_PLAN_MEMBER_SUCCESS,
  EDIT_PLAN_PROBLEM_FAIL,
  EDIT_PLAN_PROBLEM_REQUEST,
  EDIT_PLAN_PROBLEM_SUCCESS,
  EDIT_PLAN_SOCIAL_CONTEXT_FAIL,
  EDIT_PLAN_SOCIAL_CONTEXT_REQUEST,
  EDIT_PLAN_SOCIAL_CONTEXT_SUCCESS,
  GET_CARE_PLAN_FAIL,
  GET_CARE_PLAN_REQUEST,
  GET_CARE_PLAN_SUCCESS,
  GET_CARE_PLAN_SUMMARY_FAIL,
  GET_CARE_PLAN_SUMMARY_REQUEST,
  GET_CARE_PLAN_SUMMARY_SUCCESS,
  GET_PLAN_ASSESSMENT_FAIL,
  GET_PLAN_ASSESSMENT_REQUEST,
  GET_PLAN_ASSESSMENT_SUCCESS,
  GET_PLAN_GOALS_LIST_FAIL,
  GET_PLAN_GOALS_LIST_REQUEST,
  GET_PLAN_GOALS_LIST_SUCCESS,
  GET_PLAN_INTERVENTIONS_LIST_FAIL,
  GET_PLAN_INTERVENTIONS_LIST_REQUEST,
  GET_PLAN_INTERVENTIONS_LIST_SUCCESS,
  GET_PLAN_MEDICATIONS_LIST_FAIL,
  GET_PLAN_MEDICATIONS_LIST_REQUEST,
  GET_PLAN_MEDICATIONS_LIST_SUCCESS,
  GET_PLAN_MEMBERS_LIST_FAIL,
  GET_PLAN_MEMBERS_LIST_REQUEST,
  GET_PLAN_MEMBERS_LIST_SUCCESS,
  GET_PLAN_PROBLEMS_LIST_FAIL,
  GET_PLAN_PROBLEMS_LIST_REQUEST,
  GET_PLAN_PROBLEMS_LIST_SUCCESS,
  GET_PLAN_SOCIAL_CONTEXT_FAIL,
  GET_PLAN_SOCIAL_CONTEXT_REQUEST,
  GET_PLAN_SOCIAL_CONTEXT_SUCCESS,
  GET_PLAN_VERSIONS_LIST_FAIL,
  GET_PLAN_VERSIONS_LIST_REQUEST,
  GET_PLAN_VERSIONS_LIST_SUCCESS,
  RESET_CREATE_CARE_PLAN,
  RESET_CREATE_GOAL_PLAN,
  RESET_CREATE_MEDICATION_PLAN,
  RESET_CREATE_PLAN_ASSESSMENT,
  RESET_CREATE_PLAN_INTERVENTION,
  RESET_CREATE_PLAN_MEMBER,
  RESET_CREATE_PLAN_PROBLEM,
  RESET_CREATE_PLAN_SOCIAL_CONTEXT,
  RESET_EDIT_GOAL_PLAN,
  RESET_EDIT_MEDICATION_PLAN,
  RESET_EDIT_PLAN_INTERVENTION,
  RESET_EDIT_PLAN_MEMBER,
  RESET_EDIT_PLAN_PROBLEM,
  RESET_EDIT_PLAN_SOCIAL_CONTEXT,
  RESET_SAVE_PLAN_VERSION,
  RESET_UPDATE_PLAN_ASSESSMENT,
  SAVE_PLAN_VERSION_FAIL,
  SAVE_PLAN_VERSION_REQUEST,
  SAVE_PLAN_VERSION_SUCCESS,
  SET_EDIT_CARE_PLAN,
  UPDATE_PLAN_ASSESSMENT_FAIL,
  UPDATE_PLAN_ASSESSMENT_REQUEST,
  UPDATE_PLAN_ASSESSMENT_SUCCESS,
} from "../../assets/constants/carePlanConstants";

// CREATE CARE PLAN REDUCER
export const createCarePlanReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_CARE_PLAN_REQUEST:
      return { loading: true };
    case CREATE_CARE_PLAN_SUCCESS:
      return { loading: false, createdCarePlan: action.payload };
    case CREATE_CARE_PLAN_FAIL:
      return { loading: false, error: action.payload };
    case RESET_CREATE_CARE_PLAN:
      return {};
    default:
      return state;
  }
};

// GET CARE PLAN REDUCER
export const getCarePlanReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CARE_PLAN_REQUEST:
      return { loading: true };
    case GET_CARE_PLAN_SUCCESS:
      return { loading: false, carePlan: action.payload };
    case GET_CARE_PLAN_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET CARE PLAN VERSIONS LIST REDUCER
export const getPlanVersionsListReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PLAN_VERSIONS_LIST_REQUEST:
      return { loading: true };
    case GET_PLAN_VERSIONS_LIST_SUCCESS:
      return { loading: false, carePlanVersionsList: action.payload };
    case GET_PLAN_VERSIONS_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// GET CARE PLAN SUMMARY REDUCER
export const getCarePlanSummaryReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_CARE_PLAN_SUMMARY_REQUEST:
      return { loading: true };
    case GET_CARE_PLAN_SUMMARY_SUCCESS:
      return { loading: false, carePlanSummary: action.payload };
    case GET_CARE_PLAN_SUMMARY_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// CREATE CARE PLAN ASSESSMENT REDUCER
export const createPlanAssessmentReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_PLAN_ASSESSMENT_REQUEST:
      return { loading: true };
    case CREATE_PLAN_ASSESSMENT_SUCCESS:
      return { loading: false, createdAssessment: action.payload };
    case CREATE_PLAN_ASSESSMENT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_CREATE_PLAN_ASSESSMENT:
      return {};
    default:
      return state;
  }
};

// GET CARE PLAN ASSESSMENT REDUCER
export const getPlanAssessmentReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PLAN_ASSESSMENT_REQUEST:
      return { loading: true };
    case GET_PLAN_ASSESSMENT_SUCCESS:
      return { loading: false, planAssessment: action.payload };
    case GET_PLAN_ASSESSMENT_FAIL:
      return { loading: false, error: action.payload };
    // case RESET_GET_PLAN_ASSESSMENT:
    //   return {};
    default:
      return state;
  }
};

// UPDATE CARE PLAN ASSESSMENT REDUCER
export const updatePlanAssessmentReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_PLAN_ASSESSMENT_REQUEST:
      return { loading: true };
    case UPDATE_PLAN_ASSESSMENT_SUCCESS:
      return { loading: false, updatedAssessment: action.payload };
    case UPDATE_PLAN_ASSESSMENT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_UPDATE_PLAN_ASSESSMENT:
      return {};
    default:
      return state;
  }
};

// CREATE CARE PLAN PROBLEM REDUCER
export const createPlanProblemReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_PLAN_PROBLEM_REQUEST:
      return { loading: true };
    case CREATE_PLAN_PROBLEM_SUCCESS:
      return { loading: false, createdPlanProblem: action.payload };
    case CREATE_PLAN_PROBLEM_FAIL:
      return { loading: false, error: action.payload };
    case RESET_CREATE_PLAN_PROBLEM:
      return {};
    default:
      return state;
  }
};

// GET CARE PLAN LIST PROBLEM REDUCER
export const getPlanProblemsListReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PLAN_PROBLEMS_LIST_REQUEST:
      return { loading: true };
    case GET_PLAN_PROBLEMS_LIST_SUCCESS:
      return { loading: false, planProblemsList: action.payload };
    case GET_PLAN_PROBLEMS_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// EDIT PLAN PROBLEM REDUCER
export const editPlanProblemReducer = (state = {}, action) => {
  switch (action.type) {
    case EDIT_PLAN_PROBLEM_REQUEST:
      return { loading: true };
    case EDIT_PLAN_PROBLEM_SUCCESS:
      return { loading: false, editedPlanProblem: action.payload };
    case EDIT_PLAN_PROBLEM_FAIL:
      return { loading: false, error: action.payload };
    case RESET_EDIT_PLAN_PROBLEM:
      return {};
    default:
      return state;
  }
};

// CREATE GOAL PLAN PROBLEM REDUCER
export const createGoalPlanReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_GOAL_PLAN_REQUEST:
      return { loading: true };
    case CREATE_GOAL_PLAN_SUCCESS:
      return { loading: false, createdGoalPlan: action.payload };
    case CREATE_GOAL_PLAN_FAIL:
      return { loading: false, error: action.payload };
    case RESET_CREATE_GOAL_PLAN:
      return {};
    default:
      return state;
  }
};

// GET CARE PLAN LIST GOAL REDUCER
export const getPlanGoalsListReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PLAN_GOALS_LIST_REQUEST:
      return { loading: true };
    case GET_PLAN_GOALS_LIST_SUCCESS:
      return { loading: false, planGoalsList: action.payload };
    case GET_PLAN_GOALS_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// EDIT GOAL PLAN PROBLEM REDUCER
export const editGoalPlanReducer = (state = {}, action) => {
  switch (action.type) {
    case EDIT_GOAL_PLAN_REQUEST:
      return { loading: true };
    case EDIT_GOAL_PLAN_SUCCESS:
      return { loading: false, editedGoalPlan: action.payload };
    case EDIT_GOAL_PLAN_FAIL:
      return { loading: false, error: action.payload };
    case RESET_EDIT_GOAL_PLAN:
      return {};
    default:
      return state;
  }
};

// CREATE  PLAN INTERVENTION  REDUCER
export const createPlanInterventionReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_PLAN_INTERVENTION_REQUEST:
      return { loading: true };
    case CREATE_PLAN_INTERVENTION_SUCCESS:
      return { loading: false, createdPlanIntervention: action.payload };
    case CREATE_PLAN_INTERVENTION_FAIL:
      return { loading: false, error: action.payload };
    case RESET_CREATE_PLAN_INTERVENTION:
      return {};
    default:
      return state;
  }
};

// GET CARE PLAN INTERVENTIONS LIST REDUCER
export const getPlanInterventionsListReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PLAN_INTERVENTIONS_LIST_REQUEST:
      return { loading: true };
    case GET_PLAN_INTERVENTIONS_LIST_SUCCESS:
      return { loading: false, planInterventionsList: action.payload };
    case GET_PLAN_INTERVENTIONS_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// EDIT PLAN INTERVENTION  REDUCER
export const editPlanInterventionReducer = (state = {}, action) => {
  switch (action.type) {
    case EDIT_PLAN_INTERVENTION_REQUEST:
      return { loading: true };
    case EDIT_PLAN_INTERVENTION_SUCCESS:
      return { loading: false, editedPlanIntervention: action.payload };
    case EDIT_PLAN_INTERVENTION_FAIL:
      return { loading: false, error: action.payload };
    case RESET_EDIT_PLAN_INTERVENTION:
      return {};
    default:
      return state;
  }
};

// CREATE PLAN MEDICATION  REDUCER
export const createMedicationPlanReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_MEDICATION_PLAN_REQUEST:
      return { loading: true };
    case CREATE_MEDICATION_PLAN_SUCCESS:
      return { loading: false, createdMedicationPlan: action.payload };
    case CREATE_MEDICATION_PLAN_FAIL:
      return { loading: false, error: action.payload };
    case RESET_CREATE_MEDICATION_PLAN:
      return {};
    default:
      return state;
  }
};

// GET CARE PLAN MEDICATIONS LIST REDUCER
export const getPlanMedicationsListReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PLAN_MEDICATIONS_LIST_REQUEST:
      return { loading: true };
    case GET_PLAN_MEDICATIONS_LIST_SUCCESS:
      return { loading: false, planMedicationsList: action.payload };
    case GET_PLAN_MEDICATIONS_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// EDIT PLAN MEDICATION  REDUCER
export const editMedicationPlanReducer = (state = {}, action) => {
  switch (action.type) {
    case EDIT_MEDICATION_PLAN_REQUEST:
      return { loading: true };
    case EDIT_MEDICATION_PLAN_SUCCESS:
      return { loading: false, editedMedicationPlan: action.payload };
    case EDIT_MEDICATION_PLAN_FAIL:
      return { loading: false, error: action.payload };
    case RESET_EDIT_MEDICATION_PLAN:
      return {};
    default:
      return state;
  }
};

// CREATE PLAN MEMBER  REDUCER
export const createPlanMemberReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_PLAN_MEMBER_REQUEST:
      return { loading: true };
    case CREATE_PLAN_MEMBER_SUCCESS:
      return { loading: false, createdPlanMember: action.payload };
    case CREATE_PLAN_MEMBER_FAIL:
      return { loading: false, error: action.payload };
    case RESET_CREATE_PLAN_MEMBER:
      return {};
    default:
      return state;
  }
};

// GET CARE PLAN MEMBERS LIST REDUCER
export const getPlanMembersListReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PLAN_MEMBERS_LIST_REQUEST:
      return { loading: true };
    case GET_PLAN_MEMBERS_LIST_SUCCESS:
      return { loading: false, planMembersList: action.payload };
    case GET_PLAN_MEMBERS_LIST_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// EDIT PLAN MEMBER  REDUCER
export const editPlanMemberReducer = (state = {}, action) => {
  switch (action.type) {
    case EDIT_PLAN_MEMBER_REQUEST:
      return { loading: true };
    case EDIT_PLAN_MEMBER_SUCCESS:
      return { loading: false, editedPlanMember: action.payload };
    case EDIT_PLAN_MEMBER_FAIL:
      return { loading: false, error: action.payload };
    case RESET_EDIT_PLAN_MEMBER:
      return {};
    default:
      return state;
  }
};

// CREATE PLAN SOCIAL CONTEXT  REDUCER
export const createPlanSocialContextReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_PLAN_SOCIAL_CONTEXT_REQUEST:
      return { loading: true };
    case CREATE_PLAN_SOCIAL_CONTEXT_SUCCESS:
      return { loading: false, socialContext: action.payload };
    case CREATE_PLAN_SOCIAL_CONTEXT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_CREATE_PLAN_SOCIAL_CONTEXT:
      return {};
    default:
      return state;
  }
};

// GET PLAN SOCIAL CONTEXT REDUCER
export const getPlanSocialContextReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PLAN_SOCIAL_CONTEXT_REQUEST:
      return { loading: true };
    case GET_PLAN_SOCIAL_CONTEXT_SUCCESS:
      return { loading: false, planSocialContext: action.payload };
    case GET_PLAN_SOCIAL_CONTEXT_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

// EDIT PLAN SOCIAL CONTEXT  REDUCER
export const editPlanSocialContextReducer = (state = {}, action) => {
  switch (action.type) {
    case EDIT_PLAN_SOCIAL_CONTEXT_REQUEST:
      return { loading: true };
    case EDIT_PLAN_SOCIAL_CONTEXT_SUCCESS:
      return { loading: false, editedSocialContext: action.payload };
    case EDIT_PLAN_SOCIAL_CONTEXT_FAIL:
      return { loading: false, error: action.payload };
    case RESET_EDIT_PLAN_SOCIAL_CONTEXT:
      return {};
    default:
      return state;
  }
};

// CREATE PLAN SOCIAL CONTEXT  REDUCER
export const savePlanVersionReducer = (state = {}, action) => {
  switch (action.type) {
    case SAVE_PLAN_VERSION_REQUEST:
      return { loading: true };
    case SAVE_PLAN_VERSION_SUCCESS:
      return { loading: false, savedPlanVersion: action.payload };
    case SAVE_PLAN_VERSION_FAIL:
      return { loading: false, error: action.payload };
    case RESET_SAVE_PLAN_VERSION:
      return {};
    default:
      return state;
  }
};

const initEditState = {
  isEditCarePlan: false,
};

export const editCarePlanReducer = (state = initEditState, action) => {
  switch (action.type) {
    case SET_EDIT_CARE_PLAN:
      return { isEditCarePlan: action.payload };
    default:
      return state;
  }
};
